import React from 'react';
import { Route } from 'react-router-dom';
import { Startscreen as AudioChallenge } from '../audiochallenge/startscreen/startscreen';
import { TextBookConstants } from '../constants/TextBook.constants';
import { Startscreen as Sprint } from '../sprint/StartScreen/startscreet';
var setTextBookGameRoutes = function (gameName) {
    var routes = [];
    for (var i = 1; i <= TextBookConstants.MAX_GROUPS; i++) {
        for (var j = 1; j <= TextBookConstants.MAX_PAGES; j++) {
            if (gameName === 'audio') {
                routes.push(React.createElement(Route, { key: "".concat(gameName).concat(j), path: "/".concat(gameName, "/").concat(i, "/").concat(j), element: React.createElement(AudioChallenge, { group: i - 1, page: j - 1, fromPage: true }) }));
            }
            if (gameName === 'sprint') {
                routes.push(React.createElement(Route, { key: "".concat(gameName).concat(j), path: "/".concat(gameName, "/").concat(i, "/").concat(j), element: React.createElement(Sprint, { group: i - 1, page: j - 1, fromPage: true }) }));
            }
        }
    }
    return routes;
};
export default setTextBookGameRoutes;
